export function getCustomerBookingAmount(booking = {}) {
  const pricing = booking.pricing || {};
  const scheduledTotal = Number(pricing.payment_schedule_total);
  if (Number.isFinite(scheduledTotal) && scheduledTotal > 0) return scheduledTotal;

  const artistFee = Number(
    pricing.artist_fee ?? pricing.package_fee ?? pricing.base ?? 0,
  );
  const isServiceArtist = Boolean(
    pricing.is_service_artist || pricing.service_artist || pricing.artist_type === "service",
  );

  if (artistFee > 0) {
    if (isServiceArtist) return artistFee;
    const platformFee = Number(pricing.platform_fee_net ?? pricing.platform_fee ?? 0);
    return artistFee + platformFee;
  }

  return Number(pricing.total ?? booking.total ?? 0);
}